export default __webpack_public_path__ + "static/media/gas-icon.83d5de48.png";